import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getRedirectUrl, clearRedirectUrl, getDefaultRedirectUrl } from "../../lib/utils";

const TeamLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Reset error message

    try {
      // 1. Attempt login (same as normal user)
      const response = await axios.post("/api/auth/login", {
        username,
        password,
      });

      const { token, stream } = response.data;
      // Store token + stream in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("stream", stream);

      // 2. Notice we DO NOT update "Last Login" here at all.
      //    That’s the difference from the candidate’s normal login page.

      // 3. Redirect to stored URL or default to /profile
      const redirectUrl = getRedirectUrl() || "/profile";
      clearRedirectUrl(); // Clear the stored redirect URL
      navigate(redirectUrl);
      window.location.reload();
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <div className="w-full bg-white rounded-lg shadow  md:mt-0 sm:max-w-md xl:p-0">
        <div className="fixed z-50 top-6 left-6 flex items-center mb-6">
          <div className="flex items-center mb-6 bg-[#00F2C2]">
            <img
              src="https://www.jumpstart-uk.com/wp-content/uploads/2022/05/jumpstart-logo-black.svg"
              className="h-6 my-2 px-4 sm:block hidden"
              alt="Jumpstart Logo"
            />
          </div>
        </div>
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          {/* A clear heading so your team knows they're on the "team" login */}
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
            Sign in to your account (TEAM)
          </h1>
          {error && <div className="text-red-500 text-sm">{error}</div>}
          <form
            className="gap-y-4 flex flex-col md:gap-y-6"
            onSubmit={handleSubmit}
          >
            <div>
              <label
                htmlFor="username"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Email address
              </label>
              <input
                type="username"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                id="email"
                className="bg-gray-50 border border-gray-300 text-gray-900 
                           sm:text-sm rounded-lg focus:ring-primary-600 
                           focus:border-primary-600 block w-full p-2.5"
                placeholder="rachel@jumpstart-uk.com"
                required
              />
            </div>
            <div className="relative">
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                id="password"
                placeholder="••••••••"
                className="bg-gray-50 border border-gray-300 text-gray-900 
                           sm:text-sm rounded-lg focus:ring-primary-600 
                           focus:border-primary-600 block w-full p-2.5 pr-10"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-9 flex items-center 
                           p-1 text-gray-600 hover:bg-gray-200 rounded-md"
              >
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                  </svg>
                )}
              </button>
            </div>
            <button
              type="submit"
              style={{
                backgroundColor: "rgb(0, 242, 194)",
              }}
              className="w-full text-black font-medium rounded-lg 
                         text-sm px-5 py-2.5 text-center"
            >
              Sign in (TEAM)
            </button>
            <p className="-mt-2 text-gray-700 text-sm hidden">
              <a
                href="/forgot-password"
                className="underline text-[#02B491] cursor-pointer"
              >
                Forgot password?
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TeamLogin;
